export default function validateDevotion(bundle, edition, locale) {
    const dontExpectAudio = ["fr", "th"];

    const requiredStrings = [
        "title",
        "introduction",
        "wisdom.reference",
        "wisdom.text",
        "wisdom.comment",
        "wisdom.prayer",
        "newTestament.reference",
        "newTestament.text",
        "newTestament.comment",
        "newTestament.prayer",
        "oldTestament.reference",
        "oldTestament.text",
        "oldTestament.comment",
        "oldTestament.prayer",
        "verseOfTheDayReference",
        "verseOfTheDay",
        "pippa",
        "references",
    ];

    const requiredForVariants = [
        "wisdom.contextReference",
        "newTestament.contextReference",
        "oldTestament.contextReference",
        "thoughtForTheDay",
    ];

    const requiredForYouth = ["actionForTheDay"];

    const assert = function (condition, message) {
        if (condition) return;

        throw message;
    };

    const assertString = function (key) {
        let parts = key.split(".");
        assert(bundle[parts[0]], `${parts[0]} is required`);
        if (parts.length > 1)
            assert(
                bundle[parts[0]][parts[1]],
                `${parts[0]}.${parts[1]} is required`
            );
    };

    try {
        assert(bundle["devotionId"], "devotionId is required");
        assert(isNumber(bundle["devotionId"]), "devotionId should be a number");
        let id = bundle["devotionId"];
        assert(id > 0 && id < 366, "devotionId should be between 1 and 365");

        assert(
            isBoolean(bundle["isPsalm"]),
            "isPsalm is required as a boolean"
        );

        let arr = requiredStrings;
        if (id == 296) {
            arr = arr.filter((e) => e !== "wisdom.prayer");
            arr = arr.filter((e) => e !== "newTestament.prayer");
            arr = arr.filter((e) => e !== "oldTestament.prayer");
        }
        arr.forEach(assertString);

        if (edition != "classic") {
            requiredForVariants.forEach(assertString);
        }

        if (edition == "youth") {
            requiredForYouth.forEach(assertString);
        }

        if (dontExpectAudio.indexOf(locale) != -1) return;
        assert(bundle["audio"], `audio is required`);
        assert(bundle["audio"]["url"], `audio.url is required`);
        assert(isNumber(bundle["audio"]["length"]), `audio.length is required`);
        assert(bundle["audio"]["length"] > 200, `audio.length is too short`);
        assert(bundle["audio"]["chapters"], `audio.chapters field is required`);
        assert(
            bundle["audio"]["chapters"].length > 0,
            `audio.chapters is empty`
        );
        bundle["audio"]["chapters"].forEach((chapter) => {
            assert(chapter["title"], `audio.chapter title is required`);
            assert(
                isNumber(chapter["start"]),
                `audio.chapter start should be a number`
            );
        });
    } catch (error) {
        console.log("Error", error);
        const message = error?.message ?? error;
        throw message;
    }
}

function isNumber(o) {
    return typeof o === "number" && isFinite(o);
}

function isBoolean(o) {
    return typeof o === "boolean";
}
